export type { Vec3, EngineExports, QubitState } from './types.js';
export { SDF_PRIMITIVES, SDF_OPERATORS, SDF_TRON_GRID, SDF_LIB } from './sdf.js';

/** Tron-flavoured palette shared between the homepage and the game. */
export const PALETTE = {
  /** Deep void background. */
  voidBlack: '#03060f',
  /** Primary neon cyan — Qubit + UI accents. */
  neonCyan: '#16f4ff',
  /** Secondary neon magenta — superposition ghost paths. */
  neonMagenta: '#ff2bd6',
  /** Tertiary neon amber — detectors / observation. */
  neonAmber: '#ffb020',
} as const;
